import {CompositionDto} from "../../../../../models/composition-dto";
import {ModificationLineTransfer} from "../../../../../_models/_booking/composition-override-linker-transfer";

/**
 * One entry of the Feature #534 `"compositionVariantKey"` mapping: a composition **plus** one swap combination.
 *
 * It is a `CompositionDto` — `LinkedDtoRepository` stores `ModelBase`s and `CompositionTableHelper` reads
 * `.price` off whichever mapping is active — carrying two extra facts the plain article mapping cannot have,
 * because they only exist per variant:
 *
 * - {@link articleName}: the article name on its own, WITHOUT the modification lines. `ModelBase.name` holds
 *   the newline-joined variant *label* (`compositionVariantLabel`), which suits a one-line lookup but is the
 *   wrong thing to put in a headline that renders its sub-lines separately.
 * - {@link modificationLines}: the `├`/`└` pairs themselves, so a consumer can render the connector in its own
 *   monospace column (`.modification-connector`) instead of splitting a joined string back apart. That column
 *   is what keeps `├` and `└` aligned — the whole point of rendering them as pairs rather than as text.
 */
export class CompositionVariantDto extends CompositionDto {
  /** The article name alone, e.g. `Gin Tonic` — the headline of a variant row. */
  articleName: string = "";

  /** The swap combination as the register worded it (#197/#198). Empty for the plain, unmodified variant. */
  modificationLines: ModificationLineTransfer[] = [];
}
